// Module
var code = "<div class=\"c-tooltip c-policyCounterInfoTooltip u-p+\">\n    <span ng-bind=\"::context.policyLabel | i18n\"></span>\n    <span ng-bind=\"context.policyType\"></span>\n</div>";
// Exports
module.exports = code;